import { render, staticRenderFns } from "./ProtocolComplience.vue?vue&type=template&id=668e3b6e&scoped=true&"
import script from "./ProtocolComplience.vue?vue&type=script&lang=js&"
export * from "./ProtocolComplience.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolComplience.vue?vue&type=style&index=0&id=668e3b6e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668e3b6e",
  null
  
)

export default component.exports